import Instance from '../../../Axios';

// New Actions for the app

const GetCategorias = () => async (dispatch) => {
  await Instance()
    .get(`/backend/categorias`)
    .then(({ data }) => {
      //   console.log(data);
      dispatch({ type: 'GET_CATEGORIAS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCategorias;
